<template>
  <div class="print-break-after">
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
    -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <picture-viewer :picToShow="picToShow"></picture-viewer>
      <img
        :src="$anm22.icons.getWorldIcon('deleteBlack')"
        class="close-pic"
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <!-- GRAPHICS -->
      <template v-if="mode === 'edit' || mode === 'prod'">
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Graphics", "Grafica") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <template v-if="graphicImages">
            <div
              v-for="(img, index) in graphicImages.filter((i) => i)"
              :key="'img-' + index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
            </div>
          </template>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
      </template>
      <!-- NOTE -->
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :class="[
              'input-elem com-anm22-app-textarea',
              mode === 'view' ? 'stamp' : '',
            ]"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.notes"
          ></textarea>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Production notes", "Note produzione") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :class="[
              'input-elem com-anm22-app-textarea',
              mode === 'view' ? 'stamp' : '',
            ]"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.productionNotes"
          ></textarea>
        </div>
      </div>
      <!-- INVIO NOTIFICHE -->
      <div
        v-if="docs.data.company == 'vrs' || docs.data.company == 'rvt'"
        class="wg-row input-row no-print"
      >
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Update email", "Email di aggiornamento") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div
          v-if="notificationSended || formData.notificationUpdate"
          class="wg-col wg-xs-12 wg-sm-6"
        >
          <div class="vircos-notification-sended">
            <img :src="$anm22.icons.getWorldIcon('check')" />
            {{ $anm22.strLang(lang, "Sended", "Inviata") }}
            {{
              $moment.unix(formData.notificationUpdate).format("DD/MM/YYYY HH:mm")
            }}
          </div>
        </div>
        <div v-else class="wg-col wg-xs-12 wg-sm-6">
          <div
            @click="sendUpdateNotification()"
            class="vircos-notification-send-btn"
          >
            <img :src="$anm22.icons.getWorldIcon('send')" />
            {{ $anm22.strLang(lang, "Send", "Invia") }}
          </div>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <template v-if="mode === 'edit'">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Attachment", "Allegato") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row lab-images">
          <template v-if="formData.images">
            <div
              v-for="(img, index) in formData.images.filter((i) => i)"
              :key="'img-' + index"
              class="lab-image"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
              <img
                class="com-anm22-app-img-fixed-height-m delete-image-btn"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="removeImage(index)"
              />
              <div v-if="formData.publicImage === img" class="public-image-label">
                {{ $anm22.strLang(lang, "Public", "Pubblica") }}
              </div>
              <img
                v-else
                class="com-anm22-app-img-fixed-height-m public-image-btn"
                :src="$anm22.icons.getWorldIcon('hideImage')"
                @click="setImagePublic(img)"
              />
            </div>
          </template>
          <anm22-file-uploader
            :uploadUrl="
              'vircos/fix-lab-image?idWorldProject=' + this.project.idWorldProject
            "
            :onSuccess="addImage"
          ></anm22-file-uploader>
        </div>
      </template>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div v-if="mode === 'edit'" class="wg-row">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="saveForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploaderInline.vue";
import PictureViewer from "./PictureViewer.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
      notificationSended: false,
      tabToShow: "default",
      picToShow: null,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    graphicImages() {
      if (this.useMainProjectImages) {
        if (
          this.mainProjectDocs &&
          this.mainProjectDocs.graphics &&
          this.mainProjectDocs.graphics.images
        ) {
          return this.mainProjectDocs.graphics.images;
        }
        return [];
      } else {
        return this.docs.graphics.images;
      }
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.lab = this.formData;
      docs.lab.lastUser = this.user.idWorldUser;
      docs.lab.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    showPic(img) {
      this.picToShow = img;
      this.tabToShow = "pic";
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
    addImage(data) {
      if (!this.formData.images) {
        this.formData.images = [];
      }
      this.formData.images.push(data.url);
      const docs = { ...this.docs };
      docs.lab = this.formData;
      docs.lab.lastUser = this.user.idWorldUser;
      docs.lab.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.lab;
        })
        .catch((error) => {
          /* offline */
        });
    },
    removeImage(index) {
      this.formData.images.splice(index, 1);
      if (
        this.publicImage &&
        this.formData.images["index"] == this.publicImage
      ) {
        this.publicImage = null;
      }
      const docs = { ...this.docs };
      docs.lab = this.formData;
      docs.lab.lastUser = this.user.idWorldUser;
      docs.lab.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.lab;
        })
        .catch((error) => {
          /* offline */
        });
    },
    setImagePublic(img) {
      this.formData.publicImage = img;
      const docs = { ...this.docs };
      docs.lab = this.formData;
      docs.lab.lastUser = this.user.idWorldUser;
      docs.lab.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.lab;
        })
        .catch((error) => {
          /* offline */
        });
    },
    sendUpdateNotification() {
      if (this.docs.data.email) {
        this.formData.notificationUpdate = this.$moment().unix();
        this.notificationSended = true;
        var labImage = null;
        // Cerco l'immagine da allegare
        if (this.formData.publicImage) {
          labImage = this.formData.publicImage;
        } else {
          console.log("Missing lab image");
          return null;
        }
        this.$http
          .post(
            "vircos/sendUpdateNotification",
            {
              projectId: this.project.idWorldProject,
              email: this.docs.data.email,
              name: this.docs.data.name,
              surname: this.docs.data.surname,
              labImage: labImage,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log("Notification: Missing customer e-mail");
      }
    },
  },
  created() {
    this.formData = { ...this.docs.lab };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
  },
  components: {
    Anm22FileUploader,
    PictureViewer,
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}
.input-elem {
  width: 200px;
  margin-bottom: 10px;
}
.stamp {
  height: 450px !important;
}
.pic-viewer {
  height: calc(90vh - 91px);
  width: 100%;
  justify-content: center;
  position: relative;
}
.close-pic {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}
.lab-images {
  .lab-image {
    position: relative;
    height: 100px;
    width: 100px;
    margin: 5px;
    cursor: pointer;

    .delete-image-btn {
      position: absolute;
      top: 3px;
      right: 3px;
    }

    .public-image-btn {
      position: absolute;
      bottom: 3px;
      right: 3px;
    }

    .public-image-label {
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: rgba(255, 255, 255, 0.8);
      padding: 2px 4px;
      border-radius: 4px 0 0 0;
      font-size: 12px;
    }
  }
}
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
@media print {
  .no-print {
    display: none;
  }
}
</style>
